import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden" data-id="element-64">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-65">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-66">
          {/* Left Content */}
          <div className="w-full md:w-1/2 flex flex-col items-start" data-id="element-67">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-68">
              {/* Authority seal */}
              <div className="inline-flex items-center gap-2 py-1.5 pl-1.5 pr-4 rounded-full bg-white border border-sage-dark/60 mb-6 shadow-sm" data-id="element-69">
                <span className="w-6 h-6 rounded-full bg-forest text-white flex items-center justify-center text-[10px] font-black" data-id="element-70">
                  ✓
                </span>
                <span className="text-forest text-[11px] font-bold tracking-[0.22em] uppercase" data-id="element-71">
                  Protocolo Clínico · 21 Días
                </span>
              </div>

              {/* Eyebrow */}
              <p className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-forest/60 mb-4" data-id="element-72">
                Di adiós a la hinchazón de después de comer
              </p>

              <h1 className="font-serif text-5xl md:text-6xl lg:text-[4.5rem] font-semibold tracking-tight text-forest leading-[1.02] mb-6" data-id="element-73">
                Repara tu intestino, resetea tu vida.
                <span className="block text-forest/70 italic font-normal mt-2" data-id="element-74">
                  El Protocolo Biome-Reset™
                </span>
              </h1>
              <p className="font-sans text-lg md:text-xl text-forest/75 mb-8 max-w-lg leading-relaxed" data-id="element-75">
                Elimina la inflamación y recupera tu energía con el sistema de
                restauración bio-digestiva de 21 días de GUT LABS™.
              </p>

              {/* Stack offer line */}
              <p className="font-sans text-sm md:text-[15px] text-forest font-semibold mb-10 max-w-lg leading-relaxed" data-id="element-76">
                Por solo <span className="text-forest font-bold" data-id="element-77">9,90€</span>{' '}
                accedes al sistema completo: 3 Módulos Maestro · Planificador ·
                Recetario Gourmet.
              </p>

              <div className="flex flex-col items-start gap-3 w-full sm:w-auto" data-id="element-78">
                <motion.a href="https://vyralea.com/cart/55754971611476:1?checkout" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="w-full sm:w-auto bg-[#1F4A3E] text-white px-10 py-5 rounded-full text-base md:text-lg font-bold tracking-tight text-center hover:bg-[#163530] transition-colors shadow-xl shadow-[#1F4A3E]/25" data-id="element-79">
                  QUIERO MI PROTOCOLO AHORA
                </motion.a>
                <span className="text-xs text-forest/55 font-medium pl-1" data-id="element-80">
                  Protocolo digital de acceso inmediato
                </span>
              </div>

              <div className="mt-8 flex items-center gap-6 text-sm text-forest/70 font-medium" data-id="element-81">
                <div className="flex items-center gap-2" data-id="element-82">
                  <Users className="w-4 h-4" data-id="element-83" />
                  <span data-id="element-84">+2.000 personas</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-85">
                  <ShieldCheck className="w-4 h-4" data-id="element-86" />
                  <span data-id="element-87">Garantía 30 días</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right Image Placeholder */}
          <div className="w-full md:w-1/2" data-id="element-88">
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative w-full aspect-square rounded-lg shadow-xl shadow-forest/10 overflow-hidden" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/4g37VQ4Ur5GNzKroJ3soHh/MOCKUP_BUENO.png" alt="Protocolo Biome-Reset™ de GUT LABS™ mostrado en tablet, móvil y recetario impreso" className="w-full h-full object-cover" data-id="element-90" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}